import { http } from "./httpClient";

// login/logout/isAuthenticated dropped -- there is no sign-in screen (the
// CRM's own login is the real gate; see middleware/auth.js's
// authRequired: false) and nothing in this app ever called them beyond
// AuthContext.jsx's me() on mount.
export const authApi = {
  me: () => http.get("/me/"),
  updateSettings: (patch) => http.patch("/me/", patch),
};
